import React, {FunctionComponent, StrictMode, useState} from 'react'
import {useDates} from '@App/hooks/useDates'
import Calendar from 'react-calendar'
import {CalendarIcon} from "../common/Icons"
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State} from '@App/state'
import {bindActionCreators} from "@reduxjs/toolkit";
import {XIcon} from "@heroicons/react/solid";

type DateFilterProps = {
    className?: string
    show?: boolean
}

export const AvailableDateFilter: FunctionComponent<DateFilterProps> = (props: DateFilterProps) => {

    const {formatDate} = useDates()
    const dispatch = useDispatch()
    const {changeDatesFilter} = bindActionCreators(actionCreators, dispatch)

    const dates = useSelector((state: State) => state.filters.dates)

    const [showCalendar, setShowCalendar] = useState(props.show ?? false)
    const [today] = useState(new Date)

    const expand = () => {
        setShowCalendar(true)
    }

    const close = (e) => {
        if (e.currentTarget.contains(e.relatedTarget) || props.show) {
            return
        }
        setShowCalendar(false)
    }


    // set distance on change
    const onChange = (selectedDates: Date[]): void => {
        changeDatesFilter({
            from: selectedDates.length >= 1 ? selectedDates[0] : null,
            to: selectedDates.length === 2 ? selectedDates[1] : null
        })
        !props.show && setShowCalendar(false)
    };

    const clearCalendar = (e) => {
        e.stopPropagation()
        changeDatesFilter(null)
        setShowCalendar(false)
    }

    return (
        <StrictMode>
            <div tabIndex={0} onClick={expand} onBlur={close}>
                <div className="relative md:w-80 max-w-full">
                    <div
                        className="bg-white border border-neutral-500 rounded shadow px-3 py-2 cursor-pointer">
                        {dates ? (
                            <span>
                                {formatDate(dates.from, 'EEEEEE., dd.MM.yy')} - {formatDate(dates.to, 'EEEEEE., dd.MM.yy')}
                            </span>
                        ) : (
                            <span className="text-neutral-500">
                            Datum auswählen
                        </span>
                        )}
                        {dates && (
                            <div onClick={clearCalendar} className={'absolute top-3 right-10'}>
                                <XIcon className={'w-4 h-4'}/>
                            </div>
                        )}
                    </div>
                    <div className="absolute top-2 right-2">
                        <CalendarIcon/>
                    </div>
                </div>
                <div className={`${showCalendar ? 'block' : 'hidden'}`}>
                    <Calendar
                        minDate={new Date()}
                        maxDate={new Date(today.setDate(today.getDate() + 60))}
                        onChange={onChange}
                        selectRange
                    />
                </div>
            </div>
        </StrictMode>
    )
}

